import moment from 'moment';
import React, { useState } from 'react';

const QuoteHistoryItem = ({ createdAt, createdBy, heading, color, hideBody = false, children }) => {
  const [expanded, setExpanded] = useState(!hideBody);

  const bodyStyle = {
    borderLeft: `3px solid ${color}`,
  };

  return (
    <div className="quote-history-item">
      <div
        className="quote-history-heading"
        onClick={() => setExpanded(!expanded)}
        title={expanded ? 'Collapse' : 'Expand'}
      >
        <div className="quote-circle">
          <i className="zmdi zmdi-circle" style={{ color }} />
        </div>
        {heading}
        {expanded === false && <small className="ml-1 text-muted">by {createdBy}</small>}
        <div className="quote-history-date">{moment(new Date(createdAt)).format('lll')}</div>
      </div>
      {expanded === true && hideBody === false && (
        <div className="quote-history-body" style={bodyStyle}>
          <div className="quote-history-author">{createdBy}</div>
          {children}
        </div>
      )}
    </div>
  );
};

export default QuoteHistoryItem;
